import { createSlice } from "@reduxjs/toolkit";
import { sagaActions } from "../sagas/sagaActions";

const initialState = {
  isOrderPlaced: false,
  orderNo: undefined,
  error: undefined,
  message: undefined,
};

export const orderPlacedSlice = createSlice({
  name: "orderPlaced",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(sagaActions.ORDERS_POST, (state, action) => {
        state.isOrderPlaced = false;
        state.message = undefined;
        state.error = undefined;
        state.orderNo = undefined;
      })
      .addCase(sagaActions.ORDERS_POSTED, (state, action) => {
        state.isOrderPlaced = true;
        state.message = action.data.message;
        state.orderNo = action.data.data.orderNo;
      })
      .addCase(sagaActions.ORDERS_FAILED, (state, action) => {
        state.isLoading = true;
        state.error = action.data.error;
        state.orderNo = undefined;
      })
      .addCase(sagaActions.ORDERS_RESET, (state, action) => {
        state.isOrderPlaced = false;
        state.message = undefined;
        state.error = undefined;
        state.orderNo = undefined;
      });
  },
});

export default orderPlacedSlice.reducer;
